"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Banner = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var react_grid_system_1 = require("react-grid-system");
var Button_1 = require("../../atoms/Button/Button");
var StyledBanner = (0, styled_components_1.default)("div")(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n\n  .banner-btn {\n    margin-top: ", ";\n  }\n\n  .banner-text h1 {\n    font-weight: normal;\n  }\n"], ["\n  background: ", ";\n\n  .banner-btn {\n    margin-top: ", ";\n  }\n\n  .banner-text h1 {\n    font-weight: normal;\n  }\n"])), function (props) { return props.background; }, function (props) { return (props.mobile ? "22px" : "52px"); });
var Banner = function (props) {
    var title = props.title, asset = props.asset, btnText = props.btnText, handleBtn = props.handleBtn, background = props.background, _a = props.reverse, reverse = _a === void 0 ? false : _a, _b = props.mobile, mobile = _b === void 0 ? false : _b, _c = props.className, className = _c === void 0 ? "" : _c;
    return ((0, jsx_runtime_1.jsx)(StyledBanner, __assign({ className: "wellms-component ".concat(className), mobile: mobile, background: background }, { children: (0, jsx_runtime_1.jsxs)(react_grid_system_1.Row, __assign({ align: "center", direction: reverse ? "row-reverse" : mobile ? "column-reverse" : "row" }, { children: [(0, jsx_runtime_1.jsxs)(react_grid_system_1.Col, __assign({ xs: 12, md: mobile ? 12 : 6, className: "banner-text", style: {
                        marginTop: mobile ? "20px" : "0",
                    } }, { children: [React.isValidElement(title) && ((0, jsx_runtime_1.jsx)(React.Fragment, { children: title })), (0, jsx_runtime_1.jsx)(Button_1.Button, __assign({ mode: "primary", className: "banner-btn", onClick: handleBtn, block: mobile }, { children: btnText }))] })), (0, jsx_runtime_1.jsx)(react_grid_system_1.Col, __assign({ xs: 12, md: mobile ? 12 : 6, style: {
                        textAlign: mobile ? "center" : "left",
                    } }, { children: React.isValidElement(asset) && ((0, jsx_runtime_1.jsx)(React.Fragment, { children: asset })) }))] })) })));
};
exports.Banner = Banner;
exports.default = (0, styled_components_1.withTheme)((0, styled_components_1.default)(exports.Banner)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""]))));
var templateObject_1, templateObject_2;
